const plJSON = {
  DUPLICATE_OF: 'Duplikat',
  DUPLICATED_BY: 'Zduplikowany przez',
  RELATED_TO: 'Powiązany z',
  SPLIT_TO: 'Podziel na',
  SPLIT_FROM: 'Oddziel od',
  BLOCKED_BY: 'Zablokowany przez',
  BLOCKS: 'Blokuje',
  MORE_THAN: 'Większy niż',
  LESS_THAN: 'Mniejszy niż',
  OPEN: 'Otwarte',
  IN_PROGRESS: 'W toku',
  ON_HOLD: 'Wstrzymane',
  COMPLETE: 'Zakończone',
  'home.built': 'Stworzony, aby ułatwić zarządzanie konserwacją',
  home_description:
    'Gdy tablice i karteczki samoprzylepne są chaosem, a potrzebujesz oprogramowania CMMS, które jest wystarczająco proste, aby twój zespół mógł z niego korzystać – wypróbuj Atlas',
  try_grash: 'Wypróbuj Atlas',
  login: 'Zaloguj się',
  start_trial: 'Rozpocznij darmowy okres próbny',
  'home.what': 'Co',
  'home.you_will_have': 'Będziesz mieć',
  'home.you_will_have_description':
    'Buduj efektywne, niezawodne procesy, które dadzą ci kontrolę nad konserwacją. Generuj, przydzielaj i śledź zlecenia pracy. Zarządzaj zapasami. Otrzymuj wiarygodne automatyczne raporty, które zwiększają przejrzystość i wprowadzają odpowiedzialność.',
  key_features: 'Kluczowe funkcje',
  key_features_description:
    'Niektóre funkcje, które sprawiają, że Atlas jest jednym z najlepszych systemów CMMS dostępnych obecnie',
  contribute: 'Współpracuj',
  work_orders: 'Zlecenia pracy',
  request_system: 'System zgłoszeń pracy',
  mobile_app: 'Aplikacja mobilna',
  asset_management: 'Zarządzanie zasobami',
  preventive_maintenance: 'Konserwacja zapobiegawcza',
  parts_inventory: 'Inwentaryzacja części',
  custom_dashboards: 'Spersonalizowane pulpity',
  'work-orders.title': 'Zarządzaj swoimi zleceniami pracy jak profesjonalista',
  'work-orders.description.short':
    'Przeglądaj i zarządzaj wszystkimi swoimi zadaniami',
  'work-orders.descriptions.0':
    'Masz dość stosów papierkowej roboty i zagubionych zleceń? Wszystkie te stracone elementy bezpośrednio wpływają na wynik finansowy oraz twoją reputację.',
  'work-orders.descriptions.1':
    'Dzięki Atlas możesz łatwo i szybko uporządkować wszystkie swoje zlecenia pracy, konserwacje zapobiegawcze i inne zadania w ramach zespołu w scentralizowanej bazie danych dostępnej z dowolnego urządzenia.',
  'work-orders.checks.0':
    'Wyświetl wszystkie swoje zadania, w tym zlecenia pracy, konserwacje oraz zgłoszenia pracy',
  'work-orders.checks.1':
    'Ustaw priorytet zadania, aby najważniejsze prace były wykonywane w pierwszej kolejności.',
  'work-orders.checks.2': 'Wyświetl kalendarz bieżących i nadchodzących zadań',
  'work-orders.checks.3':
    'Wyświetl przydziały zadań z kluczowymi informacjami, takimi jak dane zasobu, termin wykonania, priorytet i inne.',
  'work-orders.checks.4':
    'Wyświetl kluczowe wskaźniki wydajności, takie jak faktycznie wykonana praca, czas pracy oraz porównanie zadań planowanych i nieplanowanych.',
  'work-requests.title': 'Uproszczony mobilny system zgłoszeń pracy',
  'work-requests.descriptions.0':
    'Masz dość korzystania ze starego systemu opartego na telefonie i e-mailach, który skutkuje zagubionymi zgłoszeniami, ciągłymi przerwami i powieloną pracą?',
  'work-requests.descriptions.1':
    'Rozwiązanie Atlas do zarządzania konserwacją pozwala każdemu, kogo upoważnisz, zgłosić problem do działu utrzymania ruchu, wystarczy zeskanować kod QR (kod kreskowy) lub odwiedzić stronę i wpisać zgłoszenie za pomocą urządzenia mobilnego.',
  'work-requests.checks.0': 'Nigdy więcej nie zgubisz zlecenia pracy',
  'work-requests.checks.1': 'Skróć czas obsługi zgłoszeń pracy nawet o 34%',
  'work-requests.checks.2':
    'Skróć czas komunikacji z zgłaszającymi nawet o 41% (telefony, e-maile, SMS-y)',
  'mobile-app.title':
    'Mobilna aplikacja CMMS, która wzmacnia twój zespół konserwacji',
  'mobile-app.descriptions.0':
    'Dzięki naszej aplikacji mobilnej na Androida i iOS, nasi klienci osiągają lepszą organizację, komunikację, odpowiedzialność i wydajność w całym zespole konserwacji nawet do 30%',
  'mobile-app.descriptions.1':
    'Za pomocą swojego urządzenia mobilnego każdy członek zespołu konserwacji może:',
  'mobile-app.checks.0': 'Wyświetl przydzielone zlecenia pracy i konserwacje',
  'mobile-app.checks.1':
    'Zarejestruj swoje zlecenia pracy w czasie poniżej 60 sekund',
  'mobile-app.checks.2':
    'Otrzymuj natychmiastowe powiadomienia push i e-mailowe',
  'mobile-app.checks.3': 'Rozpocznij nowe zlecenia pracy będąc w terenie',
  'mobile-app.checks.4':
    'Odpowiadaj na problemy i rejestruj je podczas wykonywania pracy',
  'mobile-app.checks.5':
    'Sprawdzaj kluczowe informacje o zasobach podczas diagnozowania problemu',
  'eam.title': 'Zarządzanie aktywami przedsiębiorstwa',
  'eam.description.short': 'Poznaj swoje zasoby',
  'eam.descriptions.0':
    'Zmęczony próbami uporządkowania chaotycznego bałaganu sprzętu w firmie, zastanawiając się, czy sprzęt jest właściwie utrzymywany, nie znając kosztów jego obsługi i innych problemów związanych z zarządzaniem zasobami?',
  'eam.descriptions.1':
    'Moduł Zarządzania Aktywami w Atlas CMMS można wykorzystać do zarządzania od 10 do 1 000 000 zasobów, umożliwiając śledzenie dokładnie tego, czego potrzebujesz, w łatwy sposób i z możliwością wyszukiwania w strukturze drzewiastej.',
  'eam.checks.0': 'Znaj status swoich zasobów w każdej chwili oraz ich koszty',
  'eam.checks.1': 'Wyświetl pełne i szczegółowe logi konserwacji',
  'eam.checks.2':
    'Śledź tylko to, co chcesz, dzięki nieograniczonym polom niestandardowym',
  'eam.checks.3':
    'Uporządkuj swoje zasoby w przejrzystej hierarchii nadrzędny-podrzędny',
  'eam.checks.4':
    'Szybko i łatwo znajdź informacje za pomocą kodów QR (kodów kreskowych)',
  'eam.checks.5':
    'Otrzymuj dane o zasobach w czasie rzeczywistym dzięki połączeniu z czujnikami',
  'pm.title': 'Skuteczny program konserwacji zapobiegawczej',
  'pm.descriptions.0':
    'Przestań tracić cenne godziny na ręczne rozsyłanie list kontrolnych konserwacji oraz monitorowanie postępów zespołu w realizacji zadań.',
  'pm.descriptions.1':
    'Atlas umożliwia łatwą automatyzację harmonogramu konserwacji, dzięki czemu odpowiednia praca trafia automatycznie do właściwego technika w odpowiednim czasie dla odpowiedniego zasobu.',
  'pm.checks.0':
    'Automatyzuj harmonogram konserwacji: codziennie, tygodniowo, miesięcznie, rocznie lub na podstawie zdarzeń czy odczytów liczników',
  'pm.checks.1':
    'Automatyczne powiadomienia push i e-mail, gdy konserwacja zostanie utworzona lub gdy nadchodzi termin jej wykonania',
  'pm.checks.2':
    'Nasz intuicyjny kalendarz pozwala wyświetlić wszystkie otwarte zadania oraz nadchodzące terminy konserwacji',
  'pm.checks.3': 'Przeciągnij i upuść, aby zmienić termin wykonania',
  'pm.checks.4':
    'Po zakończeniu konserwacji praca jest automatycznie zapisywana w dzienniku utrzymania zasobu',
  'pm.checks.5': 'Wymaga minimalnego lub żadnego szkolenia',
  'part.title': 'Zyskaj kontrolę nad stanem magazynowym części zamiennych',
  'part.description.short': 'Dowiedz się, kiedy zabraknie części',
  'part.descriptions.0':
    'Nie jesteś pewien, jakie części masz na stanie lub gdzie są używane? Nie wiesz, kiedy zabraknie części lub czy technicy będą mieli niezbędne elementy do wykonania swoich zadań?',
  'part.descriptions.1':
    'Stworzyliśmy system zarządzania częściami w Atlas, aby rozwiązać te problemy i więcej:',
  'part.checks.0':
    'Otrzymuj natychmiastowe powiadomienia push i e-mail, gdy ilość danej części jest niska. Utrzymuj odpowiedni stan magazynowy, otrzymując automatyczne powiadomienia, gdy ilość spadnie poniżej ustalonego progu',
  'part.checks.1':
    'Technicy od razu wiedzą, czy część jest dostępna z poziomu zlecenia pracy. Jeśli nie, łatwo sprawdź inne lokalizacje, aby sprawdzić dostępność.',
  'part.checks.2':
    'Automatyczne śledzenie zużycia części. Gdy zlecenia pracy lub konserwacje wykorzystują części, stan magazynowy jest automatycznie aktualizowany',
  'part.checks.3':
    'Śledź użycie części. Przeglądaj dziennik części, aby zobaczyć, gdzie i przez kogo są używane',
  'part.checks.4':
    'Eliminuj nieużywane części. Dowiedz się, kiedy część stała się nieaktualna',
  'part.checks.5':
    'Raportowanie w czasie rzeczywistym. Dowiedz się, gdzie są używane części i ile cię kosztują',
  'part.checks.6':
    'Optymalizuj poziom zapasów. Natychmiast zobacz prognozę dla danej części, aby wiedzieć, ile może być użyte w ciągu roku',
  'part.checks.7':
    'Wyszukiwanie za pomocą kodu kreskowego. Ułatw śledzenie i dostęp do magazynu dzięki niestandardowym kodom QR',
  'dashboard.title':
    'Twoje dane, na twój sposób dzięki spersonalizowanym pulpitom',
  'dashboard.descriptions.0':
    'Przyznajmy, pierwszym krokiem do poprawy operacji jest poznanie dobrych, złych i niepokojących aspektów.',
  'dashboard.descriptions.1':
    'Dzięki spersonalizowanym pulpitom Atlas wreszcie możesz zrozumieć tę mroczną „czarną dziurę konserwacji” i rozpocząć wdrażanie planów opartych na danych, co prowadzi do obniżenia kosztów pracy, zmniejszenia przestojów i innych korzyści.',
  'dashboard.descriptions.2':
    'Dzięki spersonalizowanym pulpitom Atlas otrzymasz możliwość...',
  'dashboard.checks.0':
    'Dowiedz się, gdzie są wydawane twoje pieniądze i dlaczego',
  'dashboard.checks.1':
    'Dowiedz się, który zasób generuje największe koszty i dlaczego',
  'dashboard.checks.2': 'Stwórz własne, niestandardowe wskaźniki KPI',
  'dashboard.checks.3':
    'Przeglądaj raporty, które są automatycznie generowane i aktualizowane na podstawie twoich metryk',
  'dashboard.checks.4':
    'Przeglądaj raporty, które można łatwo udostępniać przez arkusze Excel, PDF lub w Atlas',
  'dashboard.checks.5': 'I wiele więcej...',
  'home.smarter': 'Inteligentniej',
  'home.work': 'Praca',
  'home.smarter_description':
    'Atlas umożliwia technikom pracę na wysokim poziomie dzięki dostępowi do narzędzi i danych niezbędnych do wykonania zadania – wszystko z poziomu ich urządzenia.',
  leading_maintenance:
    'Wyznaczamy kierunek dla lepszej przyszłości w zakresie konserwacji i niezawodności',
  premium_included: 'W zestawie funkcje premium',
  no_credit_card: 'Nie wymaga karty kredytowej',
  perfect_tool: 'Idealne narzędzie dla zespołów konserwacji',
  start_trial_today: 'Rozpocznij darmowy okres próbny już dziś',
  create_account: 'Utwórz konto',
  signup_description: 'Wypełnij poniższe pola, aby zarejestrować konto',
  account_already: 'Masz już konto?',
  signin_here: 'Zaloguj się tutaj',
  invalid_email: 'Podany adres e-mail musi być poprawny',
  required_email: 'Pole e-mail jest wymagane',
  required_firstName: 'Pole imienia jest wymagane',
  required_lastName: 'Pole nazwiska jest wymagane',
  required_company: 'Pole nazwy firmy jest wymagane',
  required_employeesCount: 'Proszę podać liczbę pracowników',
  invalid_phone: 'Numer telefonu jest nieprawidłowy',
  required_password: 'Pole hasła jest wymagane',
  required_terms: 'Musisz zaakceptować nasze warunki korzystania',
  verify_email: 'Sprawdź swoją skrzynkę e-mail, aby aktywować konto',
  registration_error: 'Rejestracja nie powiodła się',
  first_name: 'Imię',
  last_name: 'Nazwisko',
  email: 'Adres e-mail',
  phone: 'Telefon',
  password: 'Hasło',
  companyName: 'Nazwa firmy',
  employeesCount: 'Liczba pracowników',
  i_accept: 'Akceptuję',
  terms_conditions: 'warunki korzystania',
  create_your_account: 'Utwórz swoje konto',
  register: 'Zarejestruj się',
  login_description: 'Wypełnij poniższe pola, aby zalogować się na swoje konto',
  no_account_yet: 'Nie masz jeszcze konta?',
  signup_here: 'Zarejestruj się tutaj',
  wrong_credentials: 'Podano nieprawidłowe dane logowania',
  lost_password: 'Zapomniałeś hasła?',
  link_wo: 'Połącz zlecenia pracy',
  link_wo_description: 'Utwórz powiązania między zleceniami pracy',
  required_relationType: 'Wybierz typ powiązania',
  required_wo: 'Pole zlecenia pracy jest wymagane',
  this_wo: 'To zlecenie pracy',
  the_wo: 'Zlecenie pracy',
  link: 'Połącz',
  cost_description: 'Opis kosztu',
  assigned_to: 'Przydzielony do',
  category: 'Kategoria',
  date: 'Data',
  cost: 'Koszt',
  include_cost: 'Uwzględnij ten koszt w łącznym koszcie',
  include_cost_description:
    'Spowoduje to dodanie kosztu do łącznego kosztu zlecenia pracy',
  required_cost_description: 'Opis kosztu jest wymagany',
  required_cost: 'Koszt jest wymagany',
  add_cost: 'Dodaj dodatkowy koszt',
  add_cost_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać dodatkowy koszt',
  add: 'Dodaj',
  hourly_rate: 'Stawka godzinowa',
  include_time: 'Uwzględnij ten czas w łącznym czasie',
  include_time_description:
    'Spowoduje to dodanie czasu trwania do łącznego czasu spędzonego na zleceniu pracy',
  work_started_at: 'Praca rozpoczęta o',
  duration: 'Czas trwania',
  hours: 'Godziny',
  minutes: 'Minuty',
  required_hours: 'Pole godzin jest wymagane',
  required_minutes: 'Pole minut jest wymagane',
  add_time: 'Dodaj czas',
  add_time_description: 'Wypełnij poniższe pola, aby utworzyć i dodać czas',
  feedback: 'Opinie',
  feedback_description: 'Przekaż swoją opinię',
  required_feedback: 'Opinie są wymagane',
  signature: 'Podpis',
  required_signature: 'Obraz podpisu jest wymagany',
  close_wo: 'Zamknij zlecenie pracy',
  close: 'Zamknij',
  task_update_success: 'Zadanie zostało pomyślnie zaktualizowane',
  task_update_failure: 'Nie udało się zaktualizować zadania',
  notes_save_success: 'Notatki zostały zapisane pomyślnie',
  images_add_task_success: 'Obrazy zostały dodane do zadania',
  images_add_task_failure: 'Coś poszło nie tak',
  images: 'Obrazy',
  required_images: 'Proszę przesłać przynajmniej jeden obraz',
  add_images: 'Dodaj obrazy',
  tasks: 'Zadania',
  wo_archive_success: 'Zlecenie pracy zostało zarchiwizowane',
  wo_archive_failure: 'Nie udało się zarchiwizować zlecenia pracy',
  wo_archive_confirm: 'Czy na pewno chcesz zarchiwizować to zlecenie pracy?',
  quantity_change_success: 'Ilość została pomyślnie zmieniona',
  quantity_change_failure: 'Nie udało się zmienić ilości',
  details: 'Szczegóły',
  updates: 'Aktualizacje',
  id: 'ID',
  due_date: 'Termin',
  location: 'Lokalizacja',
  asset: 'Zasób',
  team: 'Zespół',
  created_at: 'Data utworzenia',
  list_view: 'Widok listy',
  calendar_view: 'Widok kalendarza',
  column_view: 'Widok kolumn',
  wo_create_success: 'Zlecenie pracy zostało pomyślnie utworzone',
  wo_create_failure: 'Nie udało się utworzyć zlecenia pracy',
  changes_saved_success: 'Zmiany zostały zapisane',
  wo_update_failure: 'Nie udało się edytować zlecenia pracy',
  wo_delete_success: 'Zlecenie pracy zostało pomyślnie usunięte',
  wo_delete_failure: 'Nie udało się usunąć zlecenia pracy',
  status: 'Status',
  title: 'Tytuł',
  priority: 'Priorytet',
  description: 'Opis',
  worker: 'Pracownik',
  location_name: 'Nazwa lokalizacji',
  location_address: 'Adres lokalizacji',
  asset_name: 'Nazwa zasobu',
  days_since_creation: 'Dni od utworzenia',
  files: 'Pliki',
  requested_by: 'Zgłoszone przez',
  completed_on: 'Zakończone w dniu',
  updated_at: 'Zaktualizowano',
  work_order: 'Zlecenie pracy',
  timer_running: 'Timer działa',
  run_timer: 'Uruchom timer',
  approved_by: 'Zatwierdzone przez',
  created_by: 'Utworzone przez',
  completed_by: 'Wykonane przez',
  time: 'Czas',
  save: 'Zapisz',
  customers: 'Kontrahenci',
  no_labor:
    'Koszty pracy nie zostały jeszcze dodane. Pojawią się tutaj, gdy użytkownik zarejestruje czas i posiada ustawioną stawkę godzinową w Atlas.',
  not_assigned: 'Nie przypisano',
  no_additional_cost: 'Dodatkowe koszty nie zostały jeszcze dodane',
  parts: 'Części',
  links: 'Linki',
  confirm_delete_file_wo:
    'Czy na pewno chcesz usunąć ten plik z tego zlecenia pracy?',
  archive: 'Archiwizuj',
  labors: 'Robocizna',
  add_additional_cost: 'Dodaj dodatkowy koszt',
  additional_costs: 'Dodatkowe koszty',
  add_parts: 'Dodaj części',
  'wo.title_description': 'Wprowadź tytuł zlecenia pracy',
  image: 'Obraz',
  estimated_duration: 'Szacowany czas trwania w godzinach',
  primary_worker: 'Główny pracownik',
  additional_workers: 'Dodatkowi pracownicy',
  select_team: 'Wybierz zespół',
  select_location: 'Wybierz lokalizację',
  select_asset: 'Wybierz zasób',
  select_tasks: 'Wybierz zadania',
  requires_signature: 'Wymaga podpisu',
  required_wo_title: 'Tytuł zlecenia pracy jest wymagany',
  add_wo: 'Dodaj zlecenie pracy',
  add_wo_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nowe zlecenie pracy',
  edit_wo: 'Edytuj zlecenie pracy',
  edit_wo_description:
    'Wypełnij poniższe pola, aby zaktualizować zlecenie pracy',
  'noRows.wo.message':
    'Zlecenia pracy to zadania lub prace, które można zaplanować lub przydzielić komuś',
  'noRows.wo.action': "Naciśnij przycisk '+' aby utworzyć zlecenie pracy",
  to_delete: 'Usuń',
  confirm_delete_wo: 'Czy na pewno chcesz usunąć to zlecenie pracy?',
  no_access_wo:
    'Nie masz dostępu do zleceń pracy. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  cancel: 'Anuluj',
  select_parts: 'Wybierz części',
  sets_of_parts: 'Zestawy części',
  paused: 'Wstrzymane',
  trigger_details: 'Szczegóły wyzwalacza',
  starts_on: 'Rozpoczyna się',
  ends_on: 'Kończy się',
  frequency: 'Częstotliwość',
  every_frequency_days: 'Co {{frequency}} dni',
  wo_details: 'Szczegóły zlecenia pracy',
  confirm_delete_file: 'Czy na pewno chcesz usunąć ten plik?',
  wo_schedule_success: 'Zlecenie pracy zostało pomyślnie zaplanowane',
  wo_schedule_failure: 'Nie udało się zaplanować zlecenia pracy',
  wo_trigger_edit_failure: 'Nie udało się edytować wyzwalacza zlecenia pracy',
  wo_trigger_delete_success:
    'Wyzwalacz zlecenia pracy został pomyślnie usunięty',
  wo_trigger_delete_failure: 'Nie udało się usunąć wyzwalacza zlecenia pracy',
  name: 'Nazwa',
  wo_title: 'Tytuł zlecenia pracy',
  next_wo: 'Następne zlecenie pracy',
  trigger_name: 'Nazwa wyzwalacza',
  enter_trigger_name: 'Wprowadź nazwę wyzwalacza',
  frequency_description: 'Częstotliwość w dniach',
  wo_configuration: 'Konfiguracja zlecenia pracy',
  required_trigger_name: 'Nazwa wyzwalacza jest wymagana',
  required_frequency: 'Częstotliwość wyzwalacza jest wymagana',
  invalid_frequency: 'Częstotliwość musi być większa niż 0',
  schedule_wo: 'Zaplanuj zlecenie pracy',
  schedule_wo_description:
    'Wypełnij poniższe pola, aby zaplanować zlecenie pracy',
  edit_wo_trigger: 'Edytuj wyzwalacz zlecenia pracy',
  edit_wo_trigger_description:
    'Wypełnij poniższe pola, aby edytować wyzwalacz zlecenia pracy',
  create_trigger: 'Utwórz wyzwalacz',
  'noRows.pm.message':
    'Planuj zlecenia pracy przy użyciu niestandardowych wyzwalaczy',
  'noRows.pm.action': "Naciśnij przycisk '+' aby utworzyć wyzwalacz",
  confirm_delete_pm: 'Czy na pewno chcesz usunąć ten wyzwalacz zlecenia pracy?',
  no_access_pm:
    'Nie masz dostępu do sekcji konserwacji zapobiegawczej. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  enter_wo_title: 'Wprowadź tytuł zlecenia pracy',
  status_report: 'Raport statusu',
  wo_analysis: 'Analiza zleceń pracy',
  wo_aging: 'Starzenie się zleceń pracy',
  time_and_cost: 'Czas i koszt',
  assets: 'Zasoby',
  reliability_dashboard: 'Panel niezawodności',
  total_maintenance_cost: 'Łączny koszt utrzymania',
  useful_life: 'Okres użytkowania',
  requests: 'Zgłoszenia',
  locations: 'Lokalizacje',
  parts_and_inventory: 'Części/Inwentarz',
  purchase_orders: 'Zamówienia',
  meters: 'Liczniki',
  people_teams: 'Ludzie i zespoły',
  people: 'Ludzie',
  teams: 'Zespoły',
  vendors_customers: 'Dostawcy i kontrahenci',
  vendors: 'Dostawcy',
  categories: 'Kategorie',
  settings: 'Ustawienia',
  cancelled: 'Anulowane',
  reject: 'Odrzuć',
  approve: 'Zatwierdź',
  request_create_success: 'Zgłoszenie zlecenia pracy zostało pomyślnie wysłane',
  request_create_failure: 'Nie udało się utworzyć zgłoszenia zlecenia pracy',
  request_edit_failure: 'Nie udało się edytować zgłoszenia',
  request_delete_success: 'Zgłoszenie zostało pomyślnie usunięte',
  request_delete_failure: 'Nie udało się usunąć zgłoszenia',
  rejected: 'Odrzucone',
  approved: 'Zatwierdzone',
  pending: 'Oczekujące',
  required_request_name: 'Tytuł zgłoszenia jest wymagany',
  required_field: 'To pole jest wymagane',
  add_request: 'Dodaj zgłoszenie',
  add_request_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nowe zgłoszenie',
  edit_request: 'Edytuj zgłoszenie',
  edit_request_description: 'Wypełnij poniższe pola, aby edytować zgłoszenie',
  'noRows.request.message': 'Zarządzaj swoimi zgłoszeniami pracy',
  'noRows.request.action': "Naciśnij przycisk '+' aby utworzyć zgłoszenie",
  confirm_delete_request: 'Czy na pewno chcesz usunąć to zgłoszenie?',
  request: 'Zgłoszenie',
  request_details: 'Szczegóły zgłoszenia',
  none_priority: 'Brak',
  low_priority: 'Niski',
  medium_priority: 'Średni',
  high_priority: 'Wysoki',
  downtimes: 'Przestoje',
  confirm_delete_file_asset:
    'Czy na pewno chcesz usunąć ten plik z tego zasobu?',
  actions: 'Akcje',
  show: 'Pokaż',
  model: 'Model',
  serial_number: 'Numer seryjny',
  operational: 'Operacyjny',
  down: 'Nie działa',
  area: 'Obszar',
  barcode: 'Kod kreskowy',
  placed_in_service: 'Wprowadzony do eksploatacji',
  warranty_expiration: 'Wygaśnięcie gwarancji',
  asset_information: 'Informacje o zasobie',
  more_informations: 'Więcej informacji',
  confirm_delete_asset_downtime: 'Czy na pewno chcesz usunąć ten przestój?',
  create_downtime_success: 'Przestój został pomyślnie dodany',
  create_downtime_failure: 'Nie udało się dodać przestoju',
  edit_downtime_success: 'Przestój został pomyślnie zaktualizowany',
  started_on: 'Rozpoczęty',
  required_startsOn: 'Data rozpoczęcia jest wymagana',
  reading_create_success: 'Odczyt został pomyślnie dodany',
  reading_create_failure: 'Nie udało się dodać odczytu',
  reading: 'Odczyt',
  added_by: 'Dodane przez',
  enter_meter_value: 'Wprowadź wartość licznika',
  add_reading: 'Dodaj odczyt',
  select_meter: 'Wybierz licznik',
  confirm_delete_part_asset:
    'Czy na pewno chcesz usunąć tę część z tego zasobu?',
  no_due_date: 'Bez terminu',
  due_at_date: 'Termin: {{date}}',
  no_primary_worker: 'Brak głównego pracownika',
  no_wo_linked_asset: 'Brak zlecenia pracy powiązanego z tym zasobem',
  asset_remove_success: 'Zasób został pomyślnie usunięty',
  asset_remove_failure: 'Nie udało się usunąć zasobu',
  asset_name_description: 'Wprowadź nazwę zasobu',
  select_asset_location: 'Wybierz lokalizację zasobu',
  primary_user_description: 'Wybierz użytkownika głównego',
  teams_description: 'Wybierz zespoły',
  customers_description: 'Wybierz kontrahentów',
  vendors_description: 'Wybierz dostawców',
  inServiceDate_description: 'Data wprowadzenia do eksploatacji',
  warranty_expiration_date: 'Data wygaśnięcia gwarancji',
  additional_information: 'Dodatkowe informacje',
  structure: 'Struktura',
  parent_asset: 'Zasób nadrzędny',
  asset_create_success: 'Zasób został pomyślnie utworzony',
  asset_create_failure: 'Nie udało się utworzyć zasobu',
  additional_workers_description: 'Wybierz dodatkowych pracowników',
  required_asset_name: 'Nazwa zasobu jest wymagana',
  add_asset: 'Dodaj zasób',
  add_asset_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nowy zasób',
  create_asset: 'Utwórz zasób',
  hierarchy: 'Hierarchia',
  add_downtime: 'Dodaj przestój',
  edit_downtime: 'Edytuj przestój',
  remove_downtime: 'Usuń przestój',
  edit: 'Edytuj',
  edit_asset: 'Edytuj zasób',
  edit_asset_description: 'Wypełnij poniższe pola, aby edytować ten zasób',
  confirm_delete_asset: 'Czy na pewno chcesz usunąć ten zasób?',
  loading_assets: 'Ładowanie zasobów pod {{name}} #{{id}}',
  no_content: 'Brak zawartości',
  no_result_criteria: 'Żaden wynik nie odpowiada kryteriom wyszukiwania',
  map_view: 'Widok mapy',
  location_create_success: 'Lokalizacja została pomyślnie utworzona',
  location_create_failure: 'Nie udało się utworzyć lokalizacji',
  location_edit_failure: 'Nie udało się edytować lokalizacji',
  location_delete_success: 'Lokalizacja została pomyślnie usunięta',
  location_delete_failure: 'Nie udało się usunąć lokalizacji',
  enter_location_name: 'Wprowadź nazwę lokalizacji',
  address: 'Adres',
  parent_location: 'Lokalizacja nadrzędna',
  select_workers: 'Wybierz pracowników',
  map_coordinates: 'Współrzędne mapy',
  required_location_name: 'Tytuł lokalizacji jest wymagany',
  required_location_address: 'Adres lokalizacji jest wymagany',
  add_location: 'Dodaj lokalizację',
  add_location_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nową lokalizację',
  edit_location: 'Edytuj lokalizację',
  edit_location_description:
    'Wypełnij poniższe pola, aby zaktualizować lokalizację',
  confirm_delete_location: 'Czy na pewno chcesz usunąć tę lokalizację?',
  floor_plans: 'Plany pięter',
  floor_plan: 'Plan piętra',
  floor_plan_name_description: 'Nazwa planu piętra',
  'Floor plan area in m²': 'Powierzchnia planu piętra w m²',
  upload_image: 'Załaduj obraz',
  required_floor_plan_name: 'Nazwa planu piętra jest wymagana',
  add_floor_plan: 'Dodaj nowy plan piętra',
  add_floor_plan_description:
    'Wypełnij poniższe pola, aby utworzyć nowy plan piętra',
  no_asset_in_location: 'Brak zasobu w tej lokalizacji',
  no_wo_in_location: 'Brak zlecenia pracy w tej lokalizacji',
  no_file_in_location: 'Brak plików dołączonych do tej lokalizacji',
  no_floor_plan_in_location: 'Brak planu piętra w tej lokalizacji',
  assigned_teams: 'Przypisane zespoły',
  assigned_customers: 'Przypisani kontrahenci',
  assigned_vendors: 'Przypisani dostawcy',

  //no_access
  no_access_location:
    'Nie masz dostępu do lokalizacji. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_vendors_customers:
    'Nie masz dostępu do dostawców i kontrahentów. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_people_team:
    'Nie masz dostępu do ludzi i zespołów. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_analytics:
    'Nie masz dostępu do analityki. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_assets:
    'Nie masz dostępu do zasobów. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_categories:
    'Nie masz dostępu do kategorii. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_files:
    'Nie masz dostępu do plików. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_inventory:
    'Nie masz dostępu do inwentarza. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_meters:
    'Nie masz dostępu do liczników. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_purchase_orders:
    'Nie możesz utworzyć zamówienia. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_requests:
    'Nie masz dostępu do zgłoszeń. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_settings:
    'Nie masz dostępu do ustawień. Skontaktuj się z administratorem, jeśli powinieneś mieć dostęp',
  no_access_page: 'Nie masz dostępu do tej strony',
  file: 'Plik',
  'noRows.location.message':
    'Lokalizacje umożliwiają efektywniejsze zarządzanie zasobami i pracownikami',
  'noRows.location.action': "Naciśnij przycisk '+' aby utworzyć lokalizację",

  //inventory
  card_view: 'Widok karty',
  set_create_success: 'Zestaw został pomyślnie utworzony',
  set_create_failure: 'Nie udało się utworzyć zestawu',
  set_edit_failure: 'Nie udało się edytować zestawu',
  set_delete_success: 'Zestaw został pomyślnie usunięty',
  set_delete_failure: 'Nie udało się usunąć zestawu',
  total_cost: 'Łączny koszt',
  part: 'Część',
  enter_part_name: 'Wprowadź nazwę części',
  required_set_name: 'Nazwa zestawu jest wymagana',
  add_set: 'Dodaj zestaw',
  add_set_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nowy zestaw',
  create_set: 'Utwórz zestaw',
  edit_set: 'Edytuj zestaw',
  edit_set_description: 'Wypełnij poniższe pola, aby edytować zestaw',
  confirm_delete_set: 'Czy na pewno chcesz usunąć ten zestaw?',
  part_create_success: 'Część została pomyślnie utworzona',
  part_create_failure: 'Nie udało się utworzyć części',
  part_edit_failure: 'Nie udało się edytować części',
  part_delete_success: 'Część została pomyślnie usunięta',
  part_delete_failure: 'Nie udało się usunąć części',
  quantity: 'Ilość',
  open_wo: 'Otwarte zlecenia pracy',
  enter_part_category: 'Wprowadź kategorię części',
  enter_part_cost: 'Wprowadź koszt części',
  enter_part_quantity: 'Wprowadź ilość części',
  minimum_quantity: 'Minimalna ilość',
  enter_part_minimum_quantity: 'Wprowadź minimalną ilość części',
  non_stock: 'Brak na stanie',
  enter_part_barcode: 'Wprowadź kod kreskowy części',
  enter_part_area: 'Wprowadź obszar części',
  additional_part_details: 'Dodatkowe informacje o części',
  add_part: 'Dodaj część',
  add_part_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nową część',
  create_part: 'Utwórz część',
  update_part: 'Aktualizuj część',
  update_part_description: 'Wypełnij poniższe pola, aby zaktualizować część',
  'noRows.part.message':
    'Części mogą być łączone z zasobami lub używane samodzielnie',
  'noRows.part.action': "Naciśnij przycisk '+' aby utworzyć część",
  confirm_delete_part: 'Czy na pewno chcesz usunąć tę część?',
  part_details: 'Szczegóły części',
  area_details: 'Szczegóły obszaru',
  assigned_people: 'Przypisani użytkownicy',
  no_asset_related_part: 'Brak zasobu powiązanego z tą częścią',
  no_file_found: 'Nie znaleziono pliku',
  no_wo_found: 'Nie znaleziono zlecenia pracy',
  workers: 'Pracownicy',
  Parts_and_Inventory: 'Części i Inwentarz',

  //purchase order
  po_edit_failure: 'Nie udało się edytować zamówienia',
  po_delete_success: 'Zamówienie zostało pomyślnie usunięte',
  po_delete_failure: 'Nie udało się usunąć zamówienia',
  number_of_items: 'Liczba pozycji',
  total_quantity: 'Łączna ilość',
  shipping_to: 'Dostawa do',
  shipping_address: 'Adres dostawy',
  po_details: 'Szczegóły zamówienia',
  enter_po_name: 'Wprowadź nazwę zamówienia',
  additional_details: 'Dodatkowe informacje',
  vendor: 'Dostawca',
  shipping_information: 'Informacje o dostawie',
  company_name: 'Nazwa firmy',
  ship_to: 'Dostawa do',
  city: 'Miasto',
  state: 'Województwo',
  zip_code: 'Kod pocztowy',
  fax_number: 'Numer faksu',
  po_date: 'Data zamówienia',
  notes: 'Notatki',
  add_notes: 'Dodaj notatki',
  requisitioner: 'Zamawiający',
  terms: 'Warunki',
  shipping_method: 'Metoda wysyłki',
  required_name: 'Nazwa jest wymagana',
  edit_po: 'Edytuj zamówienie',
  edit_po_description: 'Wypełnij poniższe pola, aby zaktualizować zamówienie',
  purchase_order: 'Zamówienie',
  'noRows.po.message': 'Zarządzaj swoimi zamówieniami w jednym miejscu',
  'noRows.po.action': "Naciśnij przycisk '+' aby utworzyć zamówienie",
  confirm_delete_po: 'Czy na pewno chcesz usunąć to zamówienie?',
  upgrade_po: 'Upgrade, aby tworzyć zamówienia',
  new_po: 'Nowe zamówienie',
  po_create_success: 'Zamówienie zostało pomyślnie utworzone',
  select_one_part: 'Wybierz przynajmniej 1 część',
  po_create_failure: 'Nie udało się utworzyć zamówienia',
  approve_while_submitting: 'Zatwierdź podczas wysyłania',
  invalid_fax: 'Numer faksu jest nieprawidłowy',
  submit: 'Wyślij',
  each_item_superior_zero: 'Ilość każdej pozycji musi być większa niż 0',
  quantity_edit_success: 'Ilość została pomyślnie zmieniona',
  quantity_edit_failure: 'Nie udało się zmienić ilości',
  APPROVED: 'Zatwierdzone',
  PENDING: 'Oczekujące',
  REJECTED: 'Odrzucone',

  //meter
  when_reading_is: 'Gdy odczyt licznika wynosi',
  greater_than: 'Większy niż',
  lower_than: 'Mniejszy niż',
  value: 'Wartość',
  required_value: 'Wartość jest wymagana',
  required_trigger_condition: 'Warunek jest wymagany',
  wo_trigger_create_success: 'Wyzwalacz zlecenia został pomyślnie utworzony',
  wo_trigger_create_failure: 'Nie udało się utworzyć wyzwalacza zlecenia',
  add_wo_trigger: 'Dodaj wyzwalacz zlecenia',
  add_wo_trigger_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać wyzwalacz zlecenia',
  wo_trigger_edit_success: 'Wyzwalacz zlecenia został pomyślnie zaktualizowany',
  meter_create_success: 'Licznik został pomyślnie utworzony',
  meter_create_failure: 'Nie udało się utworzyć licznika',
  meter_edit_failure: 'Nie udało się edytować licznika',
  meter_delete_success: 'Licznik został pomyślnie usunięty',
  meter_delete_failure: 'Nie udało się usunąć licznika',
  next_reading_due: 'Następny odczyt zaplanowany',
  unit_of_measurement: 'Jednostka miary',
  last_reading: 'Ostatni odczyt',
  enter_meter_name: 'Wprowadź nazwę licznika',
  unit: 'Jednostka',
  update_frequency: 'Częstotliwość aktualizacji',
  update_frequency_in_days: 'Częstotliwość aktualizacji w dniach',
  required_meter_name: 'Nazwa licznika jest wymagana',
  required_meter_unit: 'Jednostka licznika jest wymagana',
  required_meter_update_frequency:
    'Częstotliwość aktualizacji licznika jest wymagana',
  required_asset: 'Zasób jest wymagany',
  add_meter: 'Dodaj licznik',
  add_meter_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nowy licznik',
  edit_meter: 'Edytuj licznik',
  edit_meter_description: 'Wypełnij poniższe pola, aby edytować licznik',
  confirm_delete_meter: 'Czy na pewno chcesz usunąć ten licznik?',
  upgrade_create_meter: 'Upgrade, aby tworzyć liczniki',
  history: 'Historia',
  reading_frequency: 'Częstotliwość odczytu',
  required_reading_value: 'Wartość odczytu jest wymagana',
  wo_triggers: 'Wyzwalacze zleceń pracy',
  add_trigger: 'Dodaj wyzwalacz',
  meter_details: 'Szczegóły licznika',
  'noRows.meter.message':
    'Odczyty liczników umożliwiają monitorowanie zasobów i wyzwalanie nowych zleceń pracy na podstawie określonych warunków',
  'noRows.meter.action': "Naciśnij przycisk '+' aby utworzyć licznik",
  meter: 'Licznik',

  //upload
  drag_one_file: 'Przeciągnij pojedynczy plik tutaj',
  drag_many_files: 'Przeciągnij i upuść pliki tutaj',
  drop_to_start: 'Upuść pliki, aby rozpocząć przesyłanie',
  invalid_files_type: 'Nie możesz przesłać tych typów plików',
  you_have_uploaded: 'Przesłałeś',
  upload: 'Prześlij',

  //vendors_customers
  Vendors_Customers: 'Dostawcy i Kontrahenci',
  customer_create_success: 'Kontrahent został pomyślnie utworzony',
  customer_create_failure: 'Nie udało się utworzyć kontrahenta',
  customer_edit_failure: 'Nie udało się edytować kontrahenta',
  customer_delete_success: 'Kontrahent został pomyślnie usunięty',
  customer_delete_failure: 'Nie udało się usunąć kontrahenta',
  customer_name: 'Nazwa kontrahenta',
  website: 'Strona internetowa',
  customer_type: 'Typ kontrahenta',
  customer_type_description: 'np. Hydraulika, Elektryka',
  customer_description_description:
    'Opisz cel tego kontrahenta w kilku zdaniach...',
  billing_information: 'Informacje rozliczeniowe',
  address_line_2: 'Linia adresu 2',
  billing_name: 'Nazwa rozliczeniowa',
  currency: 'Waluta',
  select_currency: 'Wybierz walutę',
  required_customer_name: 'Nazwa kontrahenta jest wymagana',
  required_phone: 'Numer telefonu jest wymagany',
  invalid_website: 'Nieprawidłowa strona internetowa',
  billing_address: 'Adres rozliczeniowy',
  add_customer: 'Dodaj kontrahenta',
  add_customer_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nowego kontrahenta',
  'noRows.customer.message': 'Kontrahenci to pracownicy zewnętrzni',
  'noRows.customer.action': "Naciśnij przycisk '+' aby utworzyć kontrahenta",
  type: 'Typ',
  billing_currency: 'Waluta rozliczeniowa',
  go_back: 'Wróć',
  confirm_delete_customer: 'Czy na pewno chcesz usunąć tego kontrahenta?',

  //vendor
  vendor_create_success: 'Dostawca został pomyślnie utworzony',
  vendor_create_failure: 'Nie udało się utworzyć dostawcy',
  vendor_edit_failure: 'Nie udało się edytować dostawcy',
  vendor_delete_success: 'Dostawca został pomyślnie usunięty',
  vendor_delete_failure: 'Nie udało się usunąć dostawcy',
  required_company_name: 'Nazwa firmy jest wymagana',
  vendor_type: 'Typ dostawcy',
  contact_name: 'Nazwa kontaktu',
  add_vendor: 'Dodaj dostawcę',
  add_vendor_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nowego dostawcę',
  confirm_delete_vendor: 'Czy na pewno chcesz usunąć tego dostawcę?',
  'noRows.vendor.message':
    'Dostawcy to organizacje, które dostarczają zasoby lub części',
  'noRows.vendor.action': "Naciśnij przycisk '+' aby utworzyć dostawcę",
  vendor_type_description: 'np. Hydraulika, Elektryka',

  //people teams
  role: 'Rola',
  edit_user: 'Edytuj użytkownika',
  edit_user_description: 'Wypełnij poniższe pola, aby edytować użytkownika',
  job_title: 'Stanowisko',
  invite_users: 'Zaproś użytkowników',
  bring_people_team: 'Zaproś nowych użytkowników do zespołu',
  add_20_users:
    "Możesz dodać 20 użytkowników jednocześnie, naciskając 'tab' lub 'enter' po każdym wpisaniu adresu e-mail. Duplikaty i zarejestrowane adresy zostaną usunięte podczas rejestracji.",
  enter_email: 'Wprowadź adres e-mail',
  users_invite_success: 'Użytkownicy zostali zaproszeni',
  users_invite_failure:
    'Nie udało się zaprosić użytkowników. Sprawdź liczbę członków subskrypcji.',
  please_type_emails: 'Wpisz adresy e-mail, aby zaprosić',
  please_select_role: 'Wybierz rolę',
  invite: 'Zaproś',
  team_create_success: 'Zespół został pomyślnie utworzony',
  team_create_failure: 'Nie udało się utworzyć zespołu',
  team_edit_failure: 'Nie udało się edytować zespołu',
  team_delete_success: 'Zespół został pomyślnie usunięty',
  team_delete_failure: 'Nie udało się usunąć zespołu',
  team_name: 'Nazwa zespołu',
  people_in_team: 'Członkowie zespołu',
  required_team_name: 'Nazwa zespołu jest wymagana',
  create_team: 'Utwórz zespół',
  create_team_description: 'Możesz dodać członków zespołu stąd',
  confirm_delete_team: 'Czy na pewno chcesz usunąć ten zespół?',
  overview: 'Przegląd',
  activity: 'Aktywność',
  wo_complete_last_14_days: 'Zlecenia wykonane w ciągu ostatnich 14 dni',
  no_wo_complete_last_14_days:
    'Nie ukończyłeś żadnych zleceń pracy w ciągu ostatnich dwóch tygodni',
  ADMIN_name: 'Administrator',
  ADMIN_description:
    'Administrator ma pełny dostęp, w tym możliwość edycji, dodawania i usuwania zleceń pracy oraz zgłoszeń',
  LIMITED_ADMIN_name: 'Ograniczony administrator',
  LIMITED_ADMIN_description:
    'Ograniczeni administratorzy mają taki sam dostęp jak administrator, z wyjątkiem możliwości przeglądania/edycji ustawień czy dodawania/edycji użytkowników i zespołów. Nie mogą usuwać zleceń pracy, zasobów, lokalizacji, liczników i zamówień, chyba że sami je utworzyli.',
  TECHNICIAN_name: 'Technik',
  TECHNICIAN_description:
    'Technicy mogą tworzyć i zamykać zlecenia pracy, zasoby i lokalizacje. Mogą edytować i usuwać tylko te elementy, które sami utworzyli',
  LIMITED_TECHNICIAN_name: 'Ograniczony technik',
  LIMITED_TECHNICIAN_description:
    'Ograniczeni technicy mogą widzieć tylko zlecenia pracy przypisane do nich',
  VIEW_ONLY_name: 'Tylko do oglądania',
  VIEW_ONLY_description:
    'Użytkownicy tylko do oglądania mają pełny dostęp do przeglądania, ale nie mogą edytować',
  REQUESTER_name: 'Zgłaszający',
  REQUESTER_description:
    'Zgłaszający mogą tylko wysyłać zgłoszenia pracy i przeglądać ich status',
  select_user_role: 'Wybierz rolę użytkownika',
  'noRows.team.message':
    'Zespoły pomagają zarządzać określonymi grupami ludzi.',
  'noRows.team.action': "Naciśnij przycisk '+' aby utworzyć zespół",
  user_details: 'Szczegóły użytkownika',

  //files
  file_delete_success: 'Plik został pomyślnie usunięty',
  file_delete_failure: 'Nie udało się usunąć pliku',
  uploaded_by: 'Przesłany przez',
  uploaded_on: 'Przesłany dnia',
  rename: 'Zmień nazwę',
  required_files: 'Prześlij przynajmniej jeden plik',
  required_file_name: 'Wprowadź nazwę pliku',
  add_files: 'Dodaj pliki',
  edit_file: 'Edytuj plik',
  'noRows.file.message': 'Zbierz wszystkie pliki w jednym miejscu',
  'noRows.file.action': "Naciśnij przycisk '+' aby przesłać plik",
  upgrade_files:
    'Upgrade, aby korzystać z plików w zasobach, zleceniach pracy, lokalizacjach itp.',
  parts_consumption: 'Zużycie części',
  requests_analysis: 'Analiza zgłoszeń',

  //categories,
  category_create_success: 'Kategoria została pomyślnie utworzona',
  category_create_failure: 'Nie udało się utworzyć kategorii',
  category_edit_failure: 'Nie udało się edytować kategorii',
  category_delete_success: 'Kategoria została pomyślnie usunięta',
  category_delete_failure: 'Nie udało się usunąć kategorii',
  timers: 'Liczniki',
  costs: 'Koszty',
  add_category: 'Dodaj nową kategorię',
  add_category_description:
    'Wprowadź nazwę, aby utworzyć i dodać nową kategorię',
  edit_category: 'Edytuj kategorię',
  edit_category_description: 'Wprowadź nazwę, aby edytować kategorię',
  no_category_action: "Naciśnij przycisk '+' aby dodać pierwszą kategorię",
  confirm_delete_category: 'Czy na pewno chcesz usunąć tę kategorię?',
  no_category_message:
    'Wygląda na to, że nie masz jeszcze żadnych kategorii {{categoryName}}.',
  acquisition_cost: 'Koszt nabycia',

  //settings
  general_settings: 'Ustawienia ogólne',
  request_form_configuration: 'Konfiguracja formularza zgłoszeń',
  roles: 'Role',
  checklists: 'Listy kontrolne',
  field_configuration_description:
    'Możesz oznaczyć pola jako Opcjonalne, Ukryte lub Wymagane',
  optional: 'Opcjonalne',
  required: 'Wymagane',
  hidden: 'Ukryte',
  creating_wo: 'Tworzenie zlecenia pracy',
  completing_wo: 'Zamykanie zlecenia pracy',
  role_edit_failure: 'Nie udało się edytować roli',
  edit_role: 'Edytuj rolę',
  edit_role_description: 'Wypełnij poniższe pola, aby edytować rolę',
  external_id: 'ID zewnętrzne',
  permissions: 'Uprawnienia',
  create_role_description:
    'Ta rola ma takie same uprawnienia jak administrator w Atlas, ale możesz dostosować niektóre istotne uprawnienia poniżej.',
  create_and_edit: 'Tworzenie/Edytowanie',
  to_access: 'Dostęp',
  role_delete_success: 'Rola została pomyślnie usunięta',
  role_delete_failure: 'Nie udało się usunąć roli',
  confirm_delete_role: 'Czy na pewno chcesz trwale usunąć tę rolę',
  users: 'Użytkownicy',
  paid: 'Płatne',
  free: 'Darmowe',
  role_create_success: 'Rola została pomyślnie utworzona',
  role_create_failure: 'Nie udało się utworzyć roli',
  roles_management: 'Zarządzanie rolami',
  roles_number: '{{count}} role',
  create_role: 'Utwórz rolę',
  upgrade_role: 'Upgrade, aby tworzyć role',
  add_role: 'Dodaj nową rolę',
  add_role_description:
    'Wypełnij poniższe pola, aby utworzyć i dodać nową rolę',
  parts_and_sets: 'Części i Zestawy części',
  upgrade_role_edit: 'Upgrade, aby edytować rolę',
  delete_role: 'Usuń rolę',
  upgrade_role_delete: 'Upgrade, aby usunąć rolę',
  create: 'Utwórz',
  pm_trigger: 'Wyzwalacz konserwacji zapobiegawczej',
  auto_assign_wo: 'Automatyczne przypisywanie zleceń pracy',
  auto_assign_wo_description:
    'Automatycznie przypisuj nowe zlecenia pracy osobie, która je utworzyła',
  auto_assign_requests: 'Automatyczne przypisywanie zgłoszeń',
  auto_assign_requests_description:
    'Automatycznie przypisuj nowe zgłoszenia osobie zatwierdzającej zgłoszenie',
  disable_closed_wo_notification:
    'Wyłącz powiadomienia o zamkniętych zleceniach pracy',
  disable_closed_wo_notification_description:
    'Wyłącz powiadomienia, gdy aktualizowane są zamknięte zlecenia pracy',
  ask_feedback_wo_closed: 'Poproś o opinię przy zamknięciu zlecenia pracy',
  ask_feedback_wo_closed_description:
    'Użytkownicy są proszeni o przekazanie opinii o wykonanej pracy',
  include_labor_in_total_cost: 'Uwzględnij koszty pracy w łącznym koszcie',
  include_labor_in_total_cost_description:
    'Dodaj koszty pracy do łącznego kosztu, gdy użytkownik rejestruje czas i ma ustawioną stawkę godzinową',
  enable_wo_updates_requesters:
    'Włącz aktualizacje zleceń pracy dla zgłaszających',
  enable_wo_updates_requesters_description:
    'Użytkownicy otrzymują aktualizacje dotyczące zleceń pracy, które zgłosili',
  language: 'Język',
  date_format: 'Format daty',
  business_type: 'Rodzaj działalności',
  general_asset_management: 'Ogólne zarządzanie zasobami',
  physical_asset_management: 'Fizyczne zarządzanie zasobami',

  //checklist
  checklist_delete_success: 'Lista kontrolna została pomyślnie usunięta',
  checklist_delete_failure: 'Nie udało się usunąć listy kontrolnej',
  create_checklist: 'Utwórz listę kontrolną',
  confirm_delete_checklist: 'Czy na pewno chcesz usunąć tę listę kontrolną?',
  upgrade_checklist: 'Upgrade, aby korzystać z list kontrolnych',

  //components
  upgrade_now: 'Upgrade teraz',
  total: 'Łącznie',
  sub_task_status: 'Status podzadań',
  text_field: 'Pole tekstowe',
  number_field: 'Pole liczbowe',
  inspection_check: 'Kontrola inspekcji',
  multiple_choices: 'Wielokrotny wybór',
  meter_reading: 'Odczyt licznika',
  select_user: 'Wybierz użytkownika',
  PASS: 'Zaliczony',
  FLAG: 'Oznacz',
  FAIL: 'Niezaliczony',
  enter_task_name: 'Wprowadź nazwę zadania',
  see_details: 'Zobacz szczegóły',
  concerned_asset: 'Dotyczący zasób',
  me: 'Mnie',
  remove_blank_tasks: 'Usuń puste zadania',
  remove_blank_options: 'Usuń puste opcje',
  preview: 'Podgląd',
  edit_checklist: 'Edytuj listę kontrolną',
  add_tasks: 'Dodaj zadania',
  use_a_checklist: 'Użyj listy kontrolnej',
  select_checklist: 'Wybierz listę kontrolną',
  save_checklist: 'Zapisz listę kontrolną',
  assign_tasks_description:
    'Przypisz niestandardowe zadania, które technicy mają wypełnić',
  select_date: 'Wybierz datę',
  task: 'Zadanie',
  checklist: 'Lista kontrolna',

  //analytics
  upgrade_analytics: 'Upgrade, aby zobaczyć analitykę',
  grouped_by_category: 'Pogrupowane według kategorii',
  downtime_by_asset: 'Przestoje według zasobów',
  downtime_and_costs: 'Przestoje i koszty',
  downtime_and_costs_trends: 'Trendy przestojów i kosztów',
  downtimes_trends: 'Trendy przestojów',
  repair_time_by_asset: 'Czas napraw według zasobów',
  consumed_parts_costs: 'Koszty zużytych części',
  requests_by_priority: 'Zgłoszenia według priorytetu',
  requests_trends: 'Trendy zgłoszeń',
  time_spent: 'Czas spędzony',
  grouped_by_completed_by: 'Pogrupowane według osoby wykonującej',
  grouped_by_assigned_to: 'Pogrupowane według osoby przypisanej',
  grouped_by_priority: 'Pogrupowane według priorytetu',
  completion_comparison: 'Porównanie ukończenia',
  hours_worked: 'Przepracowane godziny',
  work_remaining: 'Pozostała praca',
  wo_status: 'Status zlecenia pracy',
  cost_trends: 'Trendy kosztów',
  cost_center: 'Analiza kosztów cyklu życia zasobu',
  downtime_and_availability: 'Przestoje i dostępność',
  incomplete_wo: 'Nieukończone zlecenia pracy',
  the_numbers: 'Liczby',
  hours_and_cost_by_asset: 'Godziny i koszty według zasobu',
  completion_comparison_description:
    'Porównanie różnych typów ukończonych zleceń pracy.',
  wo_age_description:
    'Wiek zlecenia pracy to liczba dni między utworzeniem zlecenia (lub zgłoszenia pracy) a jego ukończeniem.',
  rav_description:
    'Łączny koszt jako % RAV oblicza się jako (koszt zleceń pracy dla zasobu / cena zakupu)*100. Standard branżowy to 3% dla tego wskaźnika',
  downtime_and_availability_description:
    'Dostępność oznacza procentowy czas, w którym zasoby były w stanie operacyjnym od daty wprowadzenia do eksploatacji. Całkowita liczba przestojów to liczba zdarzeń przestoju w określonym przedziale czasowym',
  total_cost_description:
    'Łączny koszt obejmuje koszty pracy, dodatkowe koszty oraz koszty części w zleceniu pracy',
  compliant_wo_description:
    'Zlecenia pracy zgodne są definiowane jako te, które zostały ukończone przed terminem. Czas cyklu to liczba dni do ukończenia zlecenia pracy.',
  hours_worked_description:
    'Te godziny odpowiadają zleceniom pracy, które mają termin wykonania w określonym przedziale czasowym',
  work_remaining_description:
    'Ten wykres pokazuje liczbę nieukończonych zleceń pracy, których termin przypada w określonym przedziale czasowym. Szacunkowe godziny odpowiadają poszczególnym zleceniom pracy.',
  total_downtime_in_hours: 'Całkowity czas przestojów (godziny)',
  downtime_events: 'Zdarzenia przestojów',
  percent_downtime: '% przestojów',
  meantime_between_failures_in_hours: 'Średni czas między awariami (godziny)',
  availability_percent: 'Procent dostępności',
  mean_time_to_repair_in_hours: 'Średni czas naprawy (godziny)',
  average_age: 'Średni wiek',
  count: 'Liczba',
  average_cost: 'Średni koszt',
  compliant: 'Zgodne',
  average_cycle_time_in_days: 'Średni czas cyklu (dni)',
  total_consumption_cost: 'Całkowity koszt zużycia',
  parts_consumed: 'Zużyte części',
  total_cost_as_pct_rav: 'Łączny koszt jako % RAV',
  approved_requests: 'Zatwierdzone zgłoszenia',
  pending_requests: 'Oczekujące zgłoszenia',
  cancelled_requests: 'Anulowane zgłoszenia',
  average_cycle_time: 'Średni czas cyklu',
  compliance_rate: 'Wskaźnik zgodności',
  complete: 'Kompletny',
  reactive: 'Reaktywny',
  recurring: 'Powtarzający się',
  part_costs: 'Koszty części',
  labor_costs: 'Koszty pracy',
  total_time_spent_in_hours: 'Łączny czas pracy (godziny)',
  estimated_hours: 'Szacowane godziny',
  total_purchase_price: 'Łączna cena zakupu',
  you_have: 'Masz',
  new_messages: 'nowych wiadomości',

  //company profile
  company: 'Firma',
  change_cover: 'Zmień okładkę',
  required_address: 'Pole adresu jest wymagane',
  company_details: 'Szczegóły firmy',
  company_details_description:
    'Zarządzaj informacjami dotyczącymi twojej firmy',
  learn_more: 'Dowiedz się więcej',

  //user profile
  profile: 'Profil',
  email_notifications: 'Powiadomienia e-mail',
  email_updates_wo: 'Aktualizacje e-mail dla zleceń pracy i wiadomości',
  email_updates_requests: 'Aktualizacje e-mail dla zgłoszonych zleceń pracy',
  po_emails: 'E-maile dotyczące zamówień',
  required_job_title: 'Pole stanowiska jest wymagane',
  required_old_password: 'Podaj obecne hasło',
  invalid_password: 'Hasło jest za krótkie - minimum 8 znaków',
  required_new_password: 'Nie podano hasła',
  passwords_must_match: 'Hasła muszą się zgadzać',
  password_change_success: 'Hasło zostało pomyślnie zmienione',
  wrong_password: 'Podano nieprawidłowe hasło',
  current_password: 'Obecne hasło',
  new_password: 'Nowe hasło',
  confirm_password: 'Potwierdź hasło',
  personal_details: 'Dane osobowe',
  personal_details_description:
    'Zarządzaj informacjami dotyczącymi twoich danych osobowych',
  change_password: 'Zmień hasło',
  notification_settings: 'Ustawienia powiadomień',
  notification_settings_description:
    'Zarządzaj szczegółami dotyczącymi powiadomień',
  recent_activity: 'Ostatnia aktywność',
  created: 'Utworzono',
  completed: 'Ukończono',
  my_account: 'Moje konto',
  my_company: 'Moja firma',
  you_are_using_plan:
    'Obecnie korzystasz z planu {{planName}}. Wygaśnie on dnia {{expiration}}. Ulepsz teraz, aby uzyskać dostęp do większej liczby funkcji.',
  upgrade_plan: 'Ulepsz plan',

  //subscription
  plans: 'Plany',
  monthly: 'Miesięczny',
  annually: 'Roczny',
  subscription_change_success: 'Subskrypcja została pomyślnie zmieniona',
  invalid_credit_card: 'Numer karty kredytowej jest nieprawidłowy',
  required_credit_card: 'Pole karty jest wymagane',
  invalid_expiration_month: 'Miesiąc wygaśnięcia jest nieprawidłowy',
  required_expiration_month: 'Miesiąc wygaśnięcia jest wymagany',
  invalid_expiration_year: 'Rok wygaśnięcia jest nieprawidłowy',
  required_expiration_year: 'Rok wygaśnięcia jest wymagany',
  invalid_cvv: 'CVV jest nieprawidłowe',
  required_cvv: 'CVV jest wymagane',
  required_cardholder_name: 'Nazwa posiadacza karty jest wymagana',
  card: 'Karta',
  expiration_month: 'Miesiąc wygaśnięcia',
  expiration_year: 'Rok wygaśnięcia',
  cardholder_name: 'Nazwa posiadacza karty',
  seats: 'Miejsca',
  cost_per_seat: 'Koszt za miejsce',
  your_payment_secure: 'Twoje dane płatnicze są szyfrowane i bezpieczne.',
  plan: 'Plan',
  current_plan: 'Obecny plan',
  number_users_who_will_use_grash: 'Liczba użytkowników korzystających z Atlas',
  admin_role: 'Administrator',
  technical_role: 'Techniczny',
  limited_technical_role: 'Ograniczony techniczny',
  requester_role: 'Zgłaszający',
  view_only_role: 'Tylko do oglądania',
  how_will_you_be_billed: 'Jak chciałbyś, abyś był rozliczany?',
  which_plan_fits_you: 'Który plan najbardziej ci odpowiada?',
  per_user_month: 'za użytkownika/miesiąc',
  per_user_year: 'za użytkownika/rok',
  you_will_be_charged: 'Zostaniesz obciążony',
  proceed_to_payment: 'Przejdź do płatności',
  pay_only_for_roles:
    'Płać tylko za użytkowników <strong>Administratora</strong>, <strong>Technicznego</strong> i <strong>Ograniczonego Technicznego</strong>, a korzystaj z nieograniczonego <strong>Zgłaszającego</strong> i <strong>Tylko do oglądania</strong> za darmo',
  checkout_our: 'Sprawdź naszą',
  pricing_page: 'Stronę z cennikiem',
  for_more_details: 'aby uzyskać więcej informacji',
  users_count_display: '{{count}} użytkowników',
  monthly_adverb: 'miesięcznie',
  yearly_adverb: 'rocznie',
  features: 'Funkcje',
  checkout: 'Zakupy',
  checkout_description: 'Wypełnij poniższe pola',
  per_month: 'za miesiąc',
  per_year: 'za rok',
  recover_password_description:
    'Wprowadź adres e-mail użyty przy rejestracji, aby zresetować hasło.',
  send_me_new_password: 'Wyślij nowe hasło',
  want_to_sign_in_again: 'Chcesz spróbować ponownie się zalogować?',
  check_mails_for_instructions:
    'Sprawdź swój e-mail, aby uzyskać dalsze instrukcje',
  pdf_report: 'Raport PDF',
  HIGH: 'Wysoki',
  MEDIUM: 'Średni',
  LOW: 'Niski',
  NONE: 'Brak',
  import: 'Importuj',
  start_import_process: 'Rozpocznij proces importu',
  import_data: 'Importuj dane',
  set_header: 'Ustaw nagłówek',
  match_columns: 'Dopasuj kolumny',
  review: 'Przejrzyj',
  done: 'Gotowe',
  no_match_yet: 'Brak dopasowania',
  select: 'Wybierz...',
  matched_to_field: 'Dopasowano do {{field}}',
  next: 'Dalej',
  not_enough_rows: 'Plik zawiera zbyt mało wierszy',
  there_are_duplicates: 'W pliku występują duplikaty: {{duplicates}}',
  assigned_by: 'Przydzielone przez',
  percent_rows_have_value: '{{percent}}% wierszy zawiera wartość',
  match_at_least_column: 'Dopasuj przynajmniej jedną kolumnę',
  to_import: 'Importuj',
  required_match: 'Dopasowanie pola {{field}} jest wymagane',
  archived: 'Zarchiwizowane',
  import_wo_success:
    '{{created}} zleceń pracy zostało utworzonych, a {{updated}} zostało zaktualizowanych',
  to_export: 'Eksportuj',
  filters: 'Filtry',
  more_filters: 'Więcej filtrów',
  customer: 'Kontrahent',
  to: 'do',
  dates: 'Daty',
  start: 'Początek',
  end: 'Koniec',
  longitude: 'Długość geograficzna',
  latitude: 'Szerokość geograficzna',
  ALL: 'Wszystko',
  REACTIVE: 'Reaktywny',
  REPEATING: 'Konserwacja zapobiegawcza',
  import_location_success:
    '{{created}} lokalizacji zostało utworzonych, a {{updated}} zostało zaktualizowanych',
  import_part_success:
    '{{created}} części zostało utworzonych, a {{updated}} zostało zaktualizowanych',
  import_meter_success:
    '{{created}} liczników zostało utworzonych, a {{updated}} zostało zaktualizowanych',
  import_asset_success:
    '{{created}} zasobów zostało utworzonych, a {{updated}} zostało zaktualizowanych',
  wo_calendar: 'Kalendarz zleceń pracy',
  month: 'Miesiąc',
  week: 'Tydzień',
  day: 'Dzień',
  agenda: 'Agenda',
  previous: 'Poprzedni',
  today: 'Dzisiaj',
  to_filter: 'Filtruj',
  'noRows.asset.message':
    'Zasoby to środki, na które twoja firma może interweniować',
  'noRows.asset.action': "Naciśnij przycisk '+' aby utworzyć nowy zasób",
  reset_filters: 'Resetuj filtry',
  toggle_menu: 'Przełącz menu',
  no_results: 'Nie znaleziono wyników',
  an_error_occured: 'Wystąpił błąd',
  density: 'Gęstość',
  compact: 'Kompaktowy',
  standard: 'Standardowy',
  comfortable: 'Komfortowy',
  columns: 'Kolumny',
  select_columns: 'Wybierz kolumny',
  show_filters: 'Pokaż filtry',
  hide_filters: 'Ukryj filtry',
  search_placeholder: 'Szukaj…',
  search: 'Szukaj',
  clear: 'Wyczyść',
  download_as_csv: 'Pobierz jako CSV',
  print: 'Drukuj',
  download_as_excel: 'Pobierz jako Excel',
  find_column: 'Znajdź kolumnę',
  column_title: 'Tytuł kolumny',
  reorder_column: 'Przestaw kolumnę',
  show_all: 'Pokaż wszystko',
  hide_all: 'Ukryj wszystko',
  add_filter: 'Dodaj filtr',
  logic_operator: 'Operator logiczny',
  operator: 'Operator',
  and: 'oraz',
  or: 'lub',
  filter_value: 'Wartość filtru',
  contains: 'zawiera',
  equals: 'równa się',
  starts_with: 'zaczyna się od',
  ends_with: 'kończy się na',
  is: 'jest',
  is_not: 'nie jest',
  is_after: 'jest po',
  is_on_or_after: 'jest w dniu lub po',
  is_before: 'jest przed',
  is_on_or_before: 'jest w dniu lub przed',
  is_empty: 'jest puste',
  is_not_empty: 'nie jest puste',
  is_any_of: 'jest dowolnym z',
  any: 'dowolny',
  true_text: 'prawda',
  false_text: 'fałsz',
  menu: 'Menu',
  show_columns: 'Pokaż kolumny',
  hide: 'Ukryj',
  unsort: 'Usuń sortowanie',
  sort_by_ASC: 'Sortuj rosnąco',
  sort_by_DESC: 'Sortuj malejąco',
  sort: 'Sortuj',
  total_rows: 'Łączna liczba wierszy:',
  yes: 'Tak',
  no: 'Nie',
  more: 'Więcej',
  to_group: 'Grupuj',
  see_children: 'zobacz potomne',
  hide_children: 'ukryj potomne',
  expand: 'Rozwiń',
  collapse: 'Zwiń',
  detail_panel_toggle: 'Przełącz panel szczegółów',
  cancel_subscription: 'Anuluj subskrypcję',
  resume_subscription: 'Wznów subskrypcję',
  confirm_cancel_subscription: 'Czy na pewno chcesz anulować subskrypcję?',
  workflows: 'Przepływy pracy',
  create_workflow: 'Utwórz przepływ pracy',
  if: 'Jeśli',
  and_optional: 'oraz (opcjonalnie)',
  then: 'wtedy',
  workflow_description:
    'Twórz niestandardowe przepływy pracy tak łatwo, jak: Jeśli, oraz, wtedy. Oszczędzaj czas i automatycznie przypisuj zlecenia pracy za pomocą przepływów, aby dostosować Atlas do działania twojego zespołu.\nWszystkie plany umożliwiają utworzenie do 1 niestandardowego przepływu pracy. Aby dodać więcej przepływów, przejdź na plan biznesowy',
  CREATE_PURCHASE_ORDER: 'Utwórz zamówienie',
  PART_IS: 'Część to',
  QUANTITY_INFERIOR: 'Ilość jest mniejsza niż',
  ASSIGN_VENDOR: 'Przypisz dostawcę',
  ASSIGN_CATEGORY: 'Przypisz kategorię',
  APPROVE: 'Zatwierdź',
  REJECT: 'Odrzuć',
  SEND_REMINDER_EMAIL: 'Wyślij przypomnienie e-mail',
  VENDOR_IS: 'Dostawca to',
  CATEGORY_IS: 'Kategoria to',
  STATUS_IS: 'Status to',
  DUE_DATE_BETWEEN: 'Termin między',
  DUE_DATE_AFTER: 'Termin po',
  ASSIGN_PRIORITY: 'Przypisz priorytet',
  ASSIGN_ASSET: 'Przypisz zasób',
  ASSIGN_LOCATION: 'Przypisz lokalizację',
  ASSIGN_USER: 'Przypisz użytkownika',
  ASSIGN_TEAM: 'Przypisz zespół',
  ADD_CHECKLIST: 'Dodaj listę kontrolną',
  PRIORITY_IS: 'Priorytet to',
  ASSET_IS: 'Zasób to',
  LOCATION_IS: 'Lokalizacja to',
  USER_IS: 'Użytkownik to',
  TEAM_IS: 'Zespół to',
  CREATED_AT_BETWEEN: 'Utworzony między',
  TITLE_CONTAINS: 'Tytuł zawiera',
  CREATE_REQUEST: 'Utwórz zgłoszenie',
  CREATE_WORK_ORDER: 'Utwórz zlecenie pracy',
  SET_ASSET_STATUS: 'Ustaw status zasobu',
  NAME_IS: 'Nazwa to',
  NAME_CONTAINS: 'Nazwa zawiera',
  VALUE_IS: 'Wartość to',
  VALUE_CONTAINS: 'Wartość zawiera',
  NUMBER_VALUE_SUPERIOR: 'Wartość jest większa niż',
  NUMBER_VALUE_INFERIOR: 'Wartość jest mniejsza niż',
  WORK_ORDER_CREATED: 'Zlecenie pracy zostało utworzone',
  WORK_ORDER_CLOSED: 'Zlecenie pracy zostało zamknięte',
  WORK_ORDER_ARCHIVED: 'Zlecenie pracy zostało zarchiwizowane',
  REQUEST_CREATED: 'Zgłoszenie zostało utworzone',
  REQUEST_APPROVED: 'Zgłoszenie zostało zatwierdzone',
  REQUEST_REJECTED: 'Zgłoszenie zostało odrzucone',
  PURCHASE_ORDER_CREATED: 'Zamówienie zostało utworzone',
  PURCHASE_ORDER_UPDATED: 'Zamówienie zostało zaktualizowane',
  TASK_UPDATED: 'Zadanie zostało zaktualizowane',
  PART_UPDATED: 'Część została zaktualizowana',
  add_condition: 'Dodaj warunek',
  workflow_creation_success: 'Przepływ pracy został pomyślnie utworzony',
  workflow_creation_failure: 'Nie udało się utworzyć przepływu pracy',
  action_value_missing: 'Brakuje wartości akcji',
  condition_value_missing: 'Brakuje wartości warunku',
  workflow_edit_success: 'Przepływ pracy został pomyślnie zaktualizowany',
  workflow_edit_failure: 'Nie udało się edytować przepływu pracy',
  workflow_delete_success: 'Przepływ pracy został pomyślnie usunięty',
  workflow_delete_failure: 'Nie udało się usunąć przepływu pracy',
  confirm_delete_workflow: 'Czy na pewno chcesz usunąć ten przepływ pracy?',
  click_here: 'Kliknij tutaj',
  verify_email_title: 'Weryfikacja e-mail',
  verify_email_description:
    'Wysłaliśmy do ciebie wiadomość weryfikacyjną. Sprawdź folder spam, jeśli nie widzisz jej w skrzynce odbiorczej.',
  upgrade: 'Ulepsz',
  downgrade: 'Obniż',
  upgrade_description:
    'Właśnie ulepszyłeś swój plan subskrypcyjny. Musisz włączyć nieaktywowanych użytkowników, którzy mogą korzystać z Atlas. Możesz to zrobić tylko raz w ramach obecnej subskrypcji. Wybierz mądrze',
  enable_users: 'Włącz użytkowników',
  max_users_description: 'Możesz włączyć do {{maxUsers}} użytkowników',
  downgrade_description:
    'Właśnie obniżyłeś swój plan subskrypcyjny. Musisz wyłączyć niektórych użytkowników, aby kontynuować. Możesz to zrobić tylko raz w ramach obecnej subskrypcji. Wybierz mądrze',
  disable_users: 'Wyłącz użytkowników',
  min_users_description:
    'Musisz wyłączyć przynajmniej {{minUsers}} użytkowników',
  downgrade_description_no_owner:
    'Twoja firma właśnie obniżyła swój plan subskrypcyjny. Właściciel firmy musi wyłączyć niektórych użytkowników, zanim będziesz mógł kontynuować',
  past_due: 'Przekroczony termin',
  due_date_delay: 'Opóźnienie terminu',
  due_date_delay_description: 'Opóźnienie terminu w dniach',
  days_count: '{{days}} dni',
  trigger_configuration: 'Konfiguracja wyzwalacza',
  WORK_ORDER_feature: 'Zlecenia pracy',
  REQUEST_feature: 'Zgłoszenia pracy',
  PART_feature: 'Zarządzanie częściami',
  MOBILE_APP_feature: 'Aplikacja mobilna',
  WORK_ORDER_HISTORY_feature: 'Historia zleceń pracy',
  PREVENTIVE_MAINTENANCE_feature: 'Konserwacja zapobiegawcza',
  CHECKLIST_feature: 'Listy kontrolne',
  FILE_feature: 'Przesyłanie plików',
  PURCHASE_ORDER_feature: 'Zamówienia',
  METER_feature: 'Odczyty liczników',
  REQUEST_CONFIGURATION_feature: 'Konfiguracja formularza zgłoszeń',
  ADDITIONAL_TIME_feature: 'Zaawansowane śledzenie czasu',
  ADDITIONAL_COST_feature: 'Zaawansowane śledzenie kosztów',
  ANALYTICS_feature: 'Analityka i raportowanie',
  REQUEST_PORTAL_feature: 'Portal zgłoszeń',
  SIGNATURE_feature: 'Podpisy',
  ROLE_feature: 'Niestandardowe role',
  WORKFLOW_feature: 'Automatyzacja przepływów pracy',
  API_ACCESS_feature: 'Dostęp do API',
  WEBHOOK_feature: 'Webhooki',
  add_new_option: 'Dodaj nową opcję',
  edit_company: 'Edytuj firmę',
  fill_fields_below: 'Wypełnij poniższe pola',
  IMPORT_CSV_feature: 'Import CSV',
  no_import_access: 'Ulepsz swój plan, aby importować z CSV, plików Excel',
  members: 'Członkowie',
  assign_user: 'Przypisz użytkownika',
  assign_asset: 'Przypisz zasób',
  required_files_on_completion:
    'Pliki są wymagane przy zamykaniu zlecenia pracy',
  required_tasks_on_completion: 'Wymagane jest wykonanie zadań',
  required_labor_on_completion: 'Musisz zarejestrować czas pracy',
  required_part_on_completion: 'W tym zleceniu pracy nie użyto żadnej części',
  required_cost_on_completion: 'Brak informacji o koszcie w tym zleceniu pracy',
  estimated_hours_in_text: '{{hours}} szacowanych godzin',
  required_part_name: 'Nazwa części jest wymagana',
  asset_update_failure: 'Nie udało się zaktualizować zasobu',
  terms_of_service: 'Warunki korzystania',
  privacy_policy: 'Polityka prywatności',
  last_login: 'Ostatnie logowanie',
  not_enough_part: 'Brak wystarczającej ilości tej części',
  remove_blank_meter_tasks: 'Usuń zadania licznika bez przypisanego licznika',
  checklist_update_failure: 'Nie udało się zaktualizować listy kontrolnej',
  contact_us: 'Skontaktuj się z nami',
  simplify_wo: 'Uprość zlecenia pracy w aplikacji mobilnej',
  simplify_wo_description:
    'Ukryj kontrolki czasu, koszty i części w szczegółach zlecenia pracy podczas korzystania z aplikacji mobilnej',
  account_deletion: 'Usunięcie konta Atlas CMMS',
  switch_account: 'Zmień konto',
  switch_to_super_user: 'Przełącz na super administratora',
  switch_account_description: 'Wybierz konto, aby kontynuować',
  put_location_in_map: 'Umieść lokalizację na mapie',
  confirm_disable_user:
    'Czy na pewno chcesz wyłączyć {{user}}? Będziesz mógł go włączyć dopiero po miesiącu',
  user_disabled_success: 'Użytkownik został pomyślnie wyłączony',
  disable: 'Wyłącz',
  manufacturer: 'Producent',
  power: 'Moc',
  import_error: 'Import nie powiódł się',
  request_upgrade: 'Poproś o ulepszenie',
  operation_success: 'Operacja zakończona sukcesem',
  CANCELLED: 'Odrzucone',
  uptime_hours: 'Czas pracy (h)',
  downtime_hours: 'Czas przestojów (h)',
  mark_all_as_seen: 'Oznacz wszystkie jako przeczytane',
  estimation_accuracy_ratio: 'Wskaźnik dokładności szacowania',
  download_template: 'Pobierz szablon',
  pareto_by_total_price: 'Pareto według łącznej ceny',
  cumulative_percent: 'Skumulowany procent',
  part_consumption_by_asset: 'Zużycie części według zasobu',
  grouped_by_wo_category: 'Pogrupowane według kategorii zleceń pracy',
  resolution_rate: 'Wskaźnik rozwiązania problemów',
  resolved: 'Rozwiązane',
  average: 'Średnia',
  documentation: 'Dokumentacja',
  days_before_pm_notification: 'Powiadomienia przed planowanym zleceniem pracy',
  estimated_start_date: 'Przewidywana data rozpoczęcia',
  no_file_linked_to_wo: 'Brak pliku powiązanego z tym zleceniem pracy',
  add_file: 'Dodaj plik',
  try_for_free: 'Wypróbuj za darmo',
  choose_your_plan: 'Wybierz swój plan',
  STARTER_description:
    'Zespoły, które chcą budować efektywną i silną konserwację zapobiegawczą poprzez widoczność stanu maszyn i zasobów ludzkich.',
  PROFESSIONAL_description:
    'Działy, które potrzebują wykorzystać analizy i dane, aby wspierać dalszy rozwój i produktywność konserwacji.',
  BUSINESS_description:
    'Organizacje gotowe do gromadzenia danych o konserwacji i operacjach w celu zarządzania wieloma lokalizacjami oraz dostosowywania systemu.',
  book_demo: 'Umów demonstrację',
  request_pricing: 'Poproś o cennik, aby uzyskać więcej informacji',
  Reports: 'Raporty',
  'Custom dashboard built using the included components':
    'Spersonalizowany pulpit stworzony przy użyciu dołączonych komponentów',
  Export: 'Eksportuj',
  'Last year': 'Ostatni rok',
  Expenses: 'Wydatki',
  Statistics: 'Statystyki',
  General: 'Ogólne',
  Calendar: 'Kalendarz',
  Mailbox: 'Skrzynka odbiorcza',
  Dashboards: 'Pulpity',
  Analytics: 'Analityka',
  Monitoring: 'Monitoring',
  Tasks: 'Zadania',
  Applications: 'Aplikacje',
  Users: 'Użytkownicy',
  'List All': 'Lista wszystkich',
  'User Profile': 'Profil użytkownika',
  Login: 'Logowanie',
  Register: 'Rejestracja',
  'Recover Password': 'Odzyskaj hasło',
  Status: 'Status',
  'Error 404': 'Błąd 404',
  'Error 500': 'Błąd 500',
  'Coming Soon': 'Wkrótce',
  Maintenance: 'Konserwacja',
  Overview: 'Przegląd',
  Documentation: 'Dokumentacja',
  Welcome: 'Witamy',
  Help: 'Pomoc',
  'Features tour': 'Przegląd funkcji',
  'Getting started guide': 'Przewodnik dla początkujących',
  'Contact support': 'Skontaktuj się z pomocą',
  Version: 'Wersja',
  Search: 'Szukaj',
  Notifications: 'Powiadomienia',
  Settings: 'Ustawienia',
  'Language Switcher': 'Przełącznik języka',
  'Sign out': 'Wyloguj się',
  'Change Theme': 'Zmień motyw',
  'View all notifications': 'Pokaż wszystkie powiadomienia',
  rate: 'oceniaj',
  select_at_least_column: 'Wybierz przynajmniej jedną kolumnę',
  already_read: 'Już przeczytane',
  OPERATIONAL: 'Operacyjny',
  DOWN: 'Nie działa',
  MODERNIZATION: 'Modernizacja',
  STANDBY: 'Gotowość',
  INSPECTION_SCHEDULED: 'Inspekcja zaplanowana',
  COMMISSIONING: 'Rozruch',
  EMERGENCY_SHUTDOWN: 'Awaryjne wyłączenie',
  select_asset_status: 'Wybierz status zasobu',
  asset_status: 'Status zasobu',
  ui_configuration: 'Konfiguracja interfejsu',
  password_leave_empty_if_you_dont_want_to_change:
    'Hasło – pozostaw puste, jeśli nie chcesz go zmieniać',
  upgrade_request_success:
    'Otrzymano prośbę o uaktualnienie! Wkrótce skontaktujemy się z Tobą w sprawie szczegółów płatności'
};

export default plJSON;
